











import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import { GamePlayer } from '@/class/gamePlayer'
import { PlayerListItemComponentInterface } from './playerListItem/PlayerListItem.vue'
import PlayerListItem from './playerListItem/PlayerListItem.vue'

export interface PlayerListComponentInterface {
  game: Game
  playerSelf?: GamePlayer
  inSelectTime: boolean
  inVoteTime: boolean
  isGallary: boolean
  isFullopen: boolean
  onClickPlayer(player: GamePlayer): void
}

@Component({
  components: {
    PlayerListItem
  }
})
export default class PlayerList extends Vue {
  @Prop() data!: PlayerListComponentInterface;

  get game() {
    return this.data.game
  }

  get playerSelf() {
    return this.data.playerSelf
  }

  get players () {
    return this.game.players.sort((a, b) => b.id === this.playerSelf?.id ? 1 : -1)
  }

  getVotedCount(playerId: string) {
    return this.game.players.filter(player => player.votedPlayerId === playerId).length
  }

  votedFirstPlace(playerId: string) {
    return this.getVotedCount(playerId) === this.votedCountList[0]
  }

  votedSecondPlace(playerId: string) {
    return this.getVotedCount(playerId) === this.votedCountList[1]
  }

  get votedCountList() {
    const votedCountList = this.game.players.map(p => this.getVotedCount(p.id)).filter(c => c !== 0)
    return Array.from(new Set(votedCountList)).sort((a, b) => b - a)
  }

  getPlayerItemData(playerId: string): PlayerListItemComponentInterface {
    return {
      ...this.data,
      playerId,
      votedCount: this.getVotedCount(playerId),
      isVotedFirstPlace: this.votedFirstPlace(playerId), 
      isVotedSecondPlace: this.votedSecondPlace(playerId),
    }
  }
}
